import {
  Input,SimpleChanges,OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {MarkerVMModel} from "../../models/MarkerModel";
import {WorkSpaceVMModel} from "../../models/WorkSpaceVMModel";
import { GoogleMapsAPIWrapper,LatLng,LatLngBounds } from '@agm/core';


@Component({

  selector: 'rw-info-box-content',  // <home></home>

  styles: [require('./map.component.css')],


  template: require('./info-box-content.component.html')
})
export class InfoBoxContentComponent implements OnInit,OnChanges {


  @Input() public content:WorkSpaceVMModel;

  /**
   * TypeScript public modifiers
   */
  constructor(private googleMapsAPI:GoogleMapsAPIWrapper) {
  }

  public ngOnInit() {
  }

  ngOnChanges(changes:SimpleChanges):void {
    let parent = this;


  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/map/info-box-content.component.ts